module.exports = __webpack_public_path__ + "static/img/RZ_pic02.c6c9337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic02.png
// module id = vYg/
// module chunks = 5